import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-media-facebook",
  "use": "social-media-facebook-usage",
  "viewBox": "0 0 48 49",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 49\" id=\"social-media-facebook\"><g fill-rule=\"evenodd\"><ellipse class=\"bg\" cx=\"23.718\" cy=\"24.359\" rx=\"23.718\" ry=\"24.359\" /><path class=\"letter\" d=\"M19.213 17.43h-5.015v-3.327c0-1.248.819-1.54 1.395-1.54h3.54V7.07l-4.875-.02c-5.41 0-6.642 4.097-6.642 6.718v3.66H4.487v5.66h3.129v16.014h6.582V23.089h4.44l.575-5.66z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol